import DIApi from './_diApi';

class ListCodeAPI extends DIApi {
  controllerName = 'ListCodes';
}

export default new ListCodeAPI();
